module.exports = __webpack_public_path__ + "img/0Q3B3199_FoamcoreMatted.89fb7ebf.jpg";